import { configureStore } from "@reduxjs/toolkit";
import loginReducer from './slices/auth/LoginSlice';
import logoutReducer from './slices/auth/LogoutSlice';
import profileReducer from './slices/profile/GetProfileSlice';
import registerReducer from './slices/auth/RegisterSlice';
import sendOtpReducer from './slices/auth/SendOtpSlice';
import socialLoginReducer from './slices/auth/SocialLoginSlice';
import verifyOtpReducer from './slices/auth/VerifyOtpSlice';
import resetPasswordReducer from './slices/auth/ResetPasswordSlice';
import getDashboardDataReducer from './slices/dashboard/GetDashboardDataSlice';
import deleteQuizReducer from '../../src/redux/slices/teams/members/DeleteQuizSlice';
import deleteSupportReducer from '../../src/redux/slices/teams/members/DeleteSupportSlice';
import deleteUserReducer from '../../src/redux/slices/teams/members/DeleteUserSlice';
import addQuizReducer from '../../src/redux/slices/teams/members/AddQuizSlice'
import addUserReducer from '../../src/redux/slices/teams/members/AddUserSlice'
import updateQuizReducer from '../../src/redux/slices/teams/members/UpdateQuizSlice'
import updateUserReducer from '../../src/redux/slices/teams/members/UpdateUserSlice'
import updateSubscriptionReducer from '../../src/redux/slices/teams/members/UpdateSubscriptionSlice'
import deleteAccountReducer from './slices/auth/DeleteAccountSlice';
import userListReducer from './slices/teams/members/GetUsersSlice';
import supportListReducer from './slices/teams/members/GetSupportSlice';
import getSupportDetailReducer from './slices/teams/members/GetSupportDetailSlice';
import updateSupportStatusReducer from './slices/teams/members/UpdateSupportStatusSlice';
import quizListReducer from './slices/teams/members/GetQuizSlice';
import subscriptionListReducer from './slices/teams/members/GetSubscriptionSlice';
import categoryListReducer from './slices/teams/members/GetCategorySlice';
import UsersDetailsReducer from './slices/teams/members/GetUserDetailsSlice';
import QuizDetailsReducer from './slices/teams/members/GetQuizDetailsSlice';
import SubscriptionDetailsReducer from './slices/teams/members/GetSubscriptionDetailsSlice';
import dashboardStatsReducer from './slices/teams/members/GetDashboardStatsSlice';
import updateProfileReducer from './slices/auth/UpdateProfileSlice';
import changePasswordReducer from './slices/auth/ChangePasswordSlice';
import inviteMembersReducer from './slices/teams/members/InviteMembersSlice';
import membersListReducer from './slices/teams/members/GetMembersSlice';
import memberExpensesReducer from './slices/teams/members/GetExpensesSlice';
import memberReportsReducer from './slices/teams/members/GetReportsSlice';
import memberInfoReducer from './slices/teams/members/GetInfoSlice';
import addCategoryReducer from './slices/teams/category/AddCategorySlice';
import editCategoryReducer from './slices/Category/EditCategorySlice';
import onboardingMembersReducer from './slices/teams/members/GetOnboardingMembersSlice';
import categoriesUploadMultipleReducer from './slices/teams/category/UploadMultipleSlice';
import getContentReducer from './slices/auth/GetContentSlice';
import membersDropdownReducer from './slices/teams/members/GetDropdownSlice';
import subscriptionSuccessReducer from './slices/auth/SubscriptionSuccessSlice';
import updateInfoReducer from './slices/teams/members/UpdateInfoSlice';
import checkInvitationReducer from './slices/auth/GetInvitationsSlice';
import acceptInvitationReducer from './slices/auth/AcceptInvitationSlice';
import rejectInvitationReducer from './slices/auth/RejectInvitationSlice';
import updateLoginReducer from './slices/auth/UpdateLoginSlice';
import notificationPreferenceReducer from './slices/auth/UpdateNotificationSlice';
import getTcReducer from './slices/teams/members/GetTcSlice';
import updateTcReducer from './slices/teams/members/UpdateTcSlice';
import sendNotificationReducer from './slices/teams/members/SendNotificationSlice';
import getNotificationReducer from './slices/notifications/GetNotificationsSlice'
import uploadBannerReducer from './slices/UploadBannerSlice';
import categoriesReducer from './slices/Category/GetCategoriesSlice';
import addNewCategoryReducer from './slices/Category/AddCategorySlice';
import verifyAdminLoginOtpReducer from './slices/auth/VerifyAdminLoginOtpSlice';
import resendAdminLoginOtpReducer from './slices/auth/ResendAdminLoginOtpSlice';
import quizFirstAttemptReducer from './slices/dashboard/GetQuizFirstAttemptSlice';


export const store = configureStore({
    reducer: {
        login: loginReducer,
        register: registerReducer,
        socialLogin: socialLoginReducer,
        sendOtp: sendOtpReducer,
        verifyOtp: verifyOtpReducer,
        resetPassword: resetPasswordReducer,
        changePassword: changePasswordReducer,
        logout: logoutReducer,
        profile: profileReducer,
        updateProfile: updateProfileReducer,
        usersList: userListReducer,
        supportList: supportListReducer,
        getSupportDetail: getSupportDetailReducer,
        updateSupportStatus: updateSupportStatusReducer,
        quizList: quizListReducer,
        subscriptionList: subscriptionListReducer,
        categoryList: categoryListReducer,
        UsersDetails: UsersDetailsReducer,
        QuizDetails: QuizDetailsReducer,
        dashboardStats: dashboardStatsReducer,
        SubscriptionDetails: SubscriptionDetailsReducer,
        getDashboardData: getDashboardDataReducer,
        subscriptionSuccess: subscriptionSuccessReducer,
        deleteQuiz: deleteQuizReducer,
        deleteSupport: deleteSupportReducer,
        deleteUser: deleteUserReducer,
        addQuiz: addQuizReducer,
        addUser: addUserReducer,
        updateQuiz: updateQuizReducer,
        updateUser: updateUserReducer,
        sendNotification: sendNotificationReducer,
        NotificationsLogs: getNotificationReducer,
        updateSubscription: updateSubscriptionReducer,
        deleteAccount: deleteAccountReducer,
        inviteMembers: inviteMembersReducer,
        membersList: membersListReducer,
        updateInfo: updateInfoReducer,
        memberExpenses: memberExpensesReducer,
        memberReports: memberReportsReducer,
        memberInfo: memberInfoReducer,
         editCategory: editCategoryReducer,
        addCategory: addCategoryReducer,
        categoryList: categoryListReducer,
        onboardingMembers: onboardingMembersReducer,
        categoriesUploadMultiple: categoriesUploadMultipleReducer,
        getContent: getContentReducer,
        membersDropdown: membersDropdownReducer,
        checkInvitation: checkInvitationReducer,
        acceptInvitation: acceptInvitationReducer,
        rejectInvitation: rejectInvitationReducer,
        updateLogin: updateLoginReducer,
        notificationPreference: notificationPreferenceReducer,
        getTc: getTcReducer,
        updateTc: updateTcReducer,
        uploadBanner: uploadBannerReducer,
        categories: categoriesReducer,
        addNewCategory: addNewCategoryReducer,
        verifyAdminLoginOtp: verifyAdminLoginOtpReducer,
        resendAdminLoginOtp: resendAdminLoginOtpReducer,
        quizFirstAttemptStats: quizFirstAttemptReducer,
    }
})